// extracted by mini-css-extract-plugin
export default {"main":"Logout_main__G+cJ1","container":"Logout_container__AX8j2"};